import { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { RegistersPaths } from '@/router';
import { HIDDEN_REGISTRY_ALIASES } from '@/api/domains/registers.types';

type RegistryAliasGuardProps = {
  children: ReactNode;
};

export const RegistryAliasGuard = ({ children }: RegistryAliasGuardProps) => {
  const { alias } = useParams<{ alias: string }>();

  if (alias && HIDDEN_REGISTRY_ALIASES.includes(alias)) {
    return <Navigate replace to={RegistersPaths.ROOT_PATH} />;
  }

  return <>{children}</>;
};
